import { combineReducers } from 'redux'
import { routerReducer as routing } from 'react-router-redux'
import { error, loading } from '@cheesecakelabs/boilerplate/reducers'

import { counter } from './counter/reducers'
import { user } from './user/reducers'
import { currentTask } from './current-task/reducers'
import { log } from './log/reducers'
import { mindfulBreaks } from './mindful-breaks/reducers'
import { todayItems } from './today-items/reducers'
import { notifications } from './notification/reducers'
import { engagement } from './engagement/reducers'
import { settings } from './settings/reducers'
import { collab } from './collaboration/reducers'
import { queueCount } from './queue-count/reducers'
import { tomorrowItems } from './tomorrow-items/reducers'
import { nonTask } from './non-task/reducers'
import { video } from './video/reducers'
import { reconcile } from './reconcile/reducers'
import { search } from './search/reducers'

const rootReducer = combineReducers({
  routing,
  error,
  loading,
  counter,
  user,
  currentTask,
  log,
  mindfulBreaks,
  todayItems,
  notifications,
  engagement,
  settings,
  collab,
  queueCount,
  tomorrowItems,
  nonTask,
  video,
  reconcile,
  search,
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/modules/reducers.js